import React from 'react';

import styles from './CredentialUsageItemSkeleton.module.scss';
import { Stack } from '@mui/material';

const CredentialUsageItemSkeleton: React.FC = () => {
  return (
    <div className={styles.container}>
      {/* Header */}
      <div className={styles.header}>
        <div className={styles.headerLeft}>
          <div className={styles.headerLeftTitleSkeleton} />
        </div>
        <div className={styles.headerRight}>
          <div className={styles.headerRightSkeleton} />
        </div>
      </div>

      {/* Content */}
      <div className={styles.content}>
        <div className={styles.contentLeft}>
          <div className={styles.chipSkeleton} />
          <div className={styles.statusSkeleton} />
          <div className={styles.chipSkeleton} />
        </div>
        <div />
      </div>
    </div>
  );
};

export const CredentialUsageItemSkeletonList: React.FC = () => {
  return (
    <Stack direction="column" gap="16px" padding="16px">
      {new Array(10).fill(0).map((_, index) => (
        <CredentialUsageItemSkeleton key={index} />
      ))}
    </Stack>
  );
};
